import React, { useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { AppContext } from '../../context/AppContext';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import BakeasyHeaderLabel from '../../components/labels/BakeasyHeaderLabel';
import { HeadCell } from '../../components/tables/BakeasyTable';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import { BakeasyNotesLabelText } from '../../components/labels/BakeasyLabelText';
import BakeasyLargeHeadingValue, {
  BakeasyLargeHeadingStatus,
} from '../../components/labels/BakeasyLargeHeadingValue';
import BakeasyLinkButton from '../../components/buttons/BakeasyLinkButton';
import BakeasyDivider from '../../components/common/BakeasyDivider';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import {
  fetchInvoicesById,
  invoiceState,
} from '../../redux_store/slices/invoicesSlice';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { isArray } from 'lodash';
import { BakeasyChip } from '../../components/common/BakeasyChip';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import dayjs from 'dayjs';
import BakeasyDatePicker from '../../components/common/BakeasyDatePicker';
import i18n from '../../languages/languages';
import * as Button from '../../components/buttons/BakeasyButtons';

export const InvoiceDetails = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [total, setTotal] = useState<any>([{}]);
  const [storeName, setStoreName] = useState<string>('');
  const [storeEmailId, setStoreEmailId] = useState<string>('');

  const [storeWork, setStoreWork] = useState<string>('');
  const [orderDate, setOrderDate] = useState<string>('');
  const [shippedDate, setShippedDate] = useState<string>('');
  const [invoicedDate, setInvoicedDate] = useState<string>('');

  const [paymentTerms, setPaymentTerms] = useState<string>('');
  const [paymentDueDate, setPaymentDueDate] = useState<string>('');

  const [shippedVia, setShippedVia] = useState<string>('');
  const [supplierName, setSupplierName] = useState<string>('');
  const [supplierNotes, setSupplierNotes] = useState<string>('');

  const [comments, setComments] = useState<string>('');
  const [storePoNo, setStorePoNo] = useState<string>('');
  const [storeId, setStoreId] = useState<string>('');
  const [products, setProducts] = useState<any[]>([]);
  const [invoiceId, setInvoiceId] = useState<string>('');
  const [orderId, setOrderId] = useState<string>('');

  const [shipTo, setShipTo] = useState<string>('');
  const [shippingName, setShippingName] = useState<string>('');
  const [shippingCompanyName, setShippingCompanyName] = useState<string>('');
  const [shippingCompanyAddress, setShippingCompanyAddress] =
    useState<string>('');
  const [shippingCity, setShippingCity] = useState<string>('');
  const [shippingState, setShippingState] = useState<string>('');
  const [shippingPostCode, setShippingPostCode] = useState<string>('');
  const [shippingCountry, setShippingCountry] = useState<string>('');
  const [storePo, setStorePo] = useState<string>('');
  const [latestSupplierNote, setLatestSupplierNote] = useState<any>(undefined);
  const [latestStoreNote, setLatestStoreNote] = useState<any>(undefined);
  const [storeNotes, setStoreNotes] = useState<string>('');
  const [shippingDate, setShippingDate] = useState<string>('');
  const [invoiceDate, setInvoiceDate] = useState<string>('');
  const [preferredShippingMethod, setPreferredShippingMethod] =
    useState<string>('');
  const [shippingRate, setShippingRate] = useState<any>('');
  const [shippingCalculation, setShippingCalculation] = useState<any>('');
  const [shippingCharges, setShippingCharges] = useState<any>('');
  const [status, setStatus] = useState<string>('');

  let { filter, selectedValue } = useAppSelector(invoiceState);

  useEffect(() => {
    fetchData(location?.state?.id);
  }, []);

  const fetchData = async (_id: any) => {
    try {
      await dispatch(fetchInvoicesById({ id: _id }));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
    }
  };

  useEffect(() => {
    if (selectedValue) {
      setData(selectedValue);
    }
  }, [selectedValue]);

  function setData(data: any) {
    setStatus(data?.status);
    setShippingName(data?.shippingName);
    // setShippingId(data?.shippingId);
    setOrderId(data?.orderId);
    setInvoiceId(data?.invoiceId ?? '-');

    // setOrderBy(data?.orderBy);
    // setHighPriority(data?.priority ? 'Yes' : 'No');
    // setRequestedDeliveryDate(data?.requestedDeliveryDate);
    setShippingDate(data?.shippedDate); //where
    setInvoiceDate(data?.invoiceDate); //where
    setOrderDate(data?.orderDate);

    setStoreId(data?.storeDetails?.storeNumber);
    setStoreName(data?.storeDetails?.storeName);
    setStoreEmailId(data?.storeDetails?.contact1?.email);
    setStoreWork(data?.storeDetails?.storeWork);
    setStorePoNo(data?.poNumber);
    setLatestStoreNote(
      data?.storeNotes
        ? data?.storeNotes?.at(data?.storeNotes?.length - 1)?.notes?.toString()
        : t('NO_STORE_NOTES_AVAILABLE')
    );
    setStoreNotes(data?.storeNotes);

    setSupplierName(data?.supplierName);
    setLatestSupplierNote(
      data?.supplierNotes
        ?.at(data?.supplierNotes?.length - 1)
        ?.notes?.toString()
    );
    // setLatestSupplierNote(
    //   data?.supplierNotes?.at(data?.supplierNotes?.length - 1)?.notes?.toString()
    // );

    setShipTo(data?.shipTo);
    setShippingName(data?.shipToInfo?.name);
    setShippingCompanyName(data?.shipToInfo?.companyName);
    setShippingCompanyAddress(data?.shipToInfo?.companyAddress);
    setShippingCity(data?.shipToInfo?.city);
    setShippingState(data?.shipToInfo?.state);
    setShippingPostCode(data?.shipToInfo?.zipCode);
    setShippingCountry(data?.shipToInfo?.country);
    // setShippingCharges(data?.shippingCharges ? 'Yes' : 'No');
    // setShippingCalculation(data?.shippingRateType);
    // setShippingRate(data?.shippingRate);
    setPreferredShippingMethod(data?.preferredShippingMethod);
    setShippingCalculation(data?.shippingRateType);
    setShippingRate(data?.shippingRate);
    setShippingCharges(
      data?.shippingCharges
        ? i18n.language === 'fr'
          ? 'Oui'
          : 'Yes'
        : i18n.language === 'fr'
          ? 'Non'
          : 'No'
    );
    // setPaymentTerms(data?.payment?.terms);
    setPaymentTerms(data?.storeDetails?.payment?.terms?.[i18n.language]);
    setPaymentDueDate(data?.requestedDeliveryDate);

    setTotal({
      ...data?.amount,
      // calculatedshippingCharge:
      //   selectedValue !== null && 'shippingRateType' in selectedValue
      //     ? selectedValue['shippingRateType'] === 'Amount'
      //       ? t('TO_BE_CONFIRMED')
      //       : data?.amount?.calculatedshippingCharge
      //     : '',
    });
    if (isArray(data?.invoicedProducts)) {
      const productDetails = data?.invoicedProducts?.map((item: any) => {
        return {
          productName: item?.productName,
          productId: item?.userProductId,
          description: item?.description,
          unitPrice: item?.price,
          totalPrice: item?.totalPrice,
          quantity: item?.quantity,
          skuId: item?.productSKU,
          //shippingQuantity: item?.shippingQuantity,
          invoiceQuantity: item?.invoicedQuantity,
          // backOrder: item?.productName
        };
      });
      setProducts([...productDetails]);
    }
  }

  const tableHeaders: HeadCell[] = [
    { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
    { id: 'productId', label: 'PRODUCT_ID', width: '160px' },
    // { id: 'skuId', numeric: false, disablePadding: true, label: 'SKU_ID', isChip: true },
    { id: 'unitPrice', label: 'UNIT_PRICE', numeric: true, width: '120px' },
    {
      id: 'quantity',
      numeric: true,
      label: 'QUANTITY_ORDERED',
      width: '120px',
      disabled: true,
    },
    // { id: 'shippingQuantity', numeric: true, label: 'QUANTITY_SHIPPED', width: '120px' },
    {
      id: 'invoiceQuantity',
      numeric: true,
      label: 'QUANTITY_INVOICED',
      width: '120px',
    },
    { id: 'totalPrice', numeric: true, label: 'TOTAL_PRICE', width: '120px' },
  ];

  function openSupplierNotesDialog(from: string, fetchMethod: any) {
    return myContext.setDialog({
      open: true,
      dialogContent: {
        pageName: 'supplierNotesHistory',
        params: { from, fetchMethod },
        onBack: async () => {},
      },
    });
  }

  function openStoreNotesDialog(isEdit: any, from: string) {
    return myContext.setDialog({
      open: true,
      dialogContent: {
        pageName: 'storeNotesHistory',
        params: { isEdit, from },
        onBack: async () => {},
      },
    });
  }

  function invoiceDetailsUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t('INVOICE_DETAILS')}
            menus={
              <>
                <Button.Print
                  onClick={function (
                    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                  ): void {
                    dispatch(
                      fetchInvoicesById({
                        id: location?.state?.id,
                        downloadType: 'pdf',
                      })
                    );
                  }}
                />
              </>
            }
            onBackClick={() => {
              navigate(-1);
            }}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingValue
                heading={t('ORDER_ID')}
                value={orderId}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingValue
                heading={t('INVOICE_ID')}
                value={invoiceId}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <BakeasyLargeHeadingStatus
                heading={t('STATUS')}
                value={<BakeasyChip label={status} />}
              />
            </Grid>
          </Grid>

          <Grid container mt={1}>
            <Grid item container>
              <BakeasyHeaderLabel message="ORDER_DETAILS" />
            </Grid>
            <Grid container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('NAME')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storeName}
                  maxLength={10}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('EMAIL_ID')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storeEmailId}
                  maxLength={10}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('MOBILE')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storeWork}
                  maxLength={10}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />
          <Grid>
            <Grid container>
              <Grid container sx={{ marginTop: 0 }}>
                <BakeasyHeaderLabel message={t('ORDER_INFO')} />
              </Grid>
            </Grid>
            <Grid container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('ORDER_DATE')}
                  disabled={true}
                  value={dayjs(orderDate)}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('SHIPPED_DATE')}
                  disabled={true}
                  value={dayjs(shippingDate)}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('INVOICE_DATE')}
                  disabled={true}
                  value={dayjs(invoiceDate)}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('PAYMENT_TERMS')}
                  disabled={true}
                  type="text"
                  name=""
                  value={paymentTerms}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyDatePicker
                  label={t('PAYMENT_DUE_DATE')}
                  disabled={true}
                  value={dayjs(paymentDueDate)}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('SUPPLIER_NAME')}
                  disabled={true}
                  type="text"
                  name=""
                  value={supplierName}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3} marginTop={1}>
                <BakeasyNotesLabelText
                  label={t('SUPPLIER_NOTES')}
                  value={latestSupplierNote}
                  maxLength={800}
                />
                <BakeasyLinkButton
                  style={{ fontSize: '0.9rem' }}
                  label={t('VIEW_ALL')}
                  onClick={() => {
                    openSupplierNotesDialog(
                      'invoiceDetails',
                      fetchInvoicesById
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />
          <Grid>
            <Grid container>
              <Grid container sx={{ marginTop: 0 }}>
                <BakeasyHeaderLabel message={t('STORE_DETAILS')} />
              </Grid>
            </Grid>
            <Grid container spacing={2} pl={2}>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('STORE_ID')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storeId}
                  maxLength={10}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <BakeasyTextField
                  label={t('STORE_PO')}
                  disabled={true}
                  type="text"
                  name=""
                  value={storePoNo}
                  maxLength={30}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3} xl={3} marginTop={1}>
                <BakeasyNotesLabelText
                  label={t('STORE_NOTES')}
                  value={latestStoreNote}
                  maxLength={800}
                />
                <BakeasyLinkButton
                  style={{ fontSize: '0.9rem' }}
                  label={t('VIEW_ALL')}
                  onClick={() => {
                    if (latestStoreNote === undefined) {
                      dispatch(
                        showErrorSnackbar({
                          message: t('NO_STORE_NOTES_AVAILABLE'),
                        })
                      );
                      return;
                    }
                    openStoreNotesDialog(false, 'invoiceDetails');
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <BakeasyDivider />

          <Grid>
            <Grid container>
              <BakeasyHeaderLabel message={t('SHIPPING_DETAILS')} />
            </Grid>
          </Grid>
          <Grid container spacing={2} pl={2}>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('SHIP_TO')}
                disabled={true}
                type="text"
                name=""
                // value={shipTo}
                value={
                  shipTo
                    ? t(`${shipTo?.toUpperCase().replace(/\s+/g, '_')}`)
                    : shipTo
                }
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('NAME')}
                disabled={true}
                type="text"
                name=""
                value={shippingName}
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('COMPANY_NAME')}
                disabled={true}
                type="text"
                name=""
                value={shippingCompanyName}
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('COUNTRY')}
                disabled={true}
                type="text"
                name=""
                // value={shippingCountry}
                value={
                  shippingCountry
                    ? t(
                        `${shippingCountry?.toUpperCase().replace(/\s+/g, '_')}`
                      )
                    : shippingCountry
                }
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('STATE')}
                disabled={true}
                type="text"
                name=""
                // value={shippingState}
                value={
                  shippingState
                    ? t(`${shippingState?.toUpperCase().replace(/\s+/g, '_')}`)
                    : shippingState
                }
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('CITY')}
                disabled={true}
                type="text"
                name=""
                value={shippingCity}
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('POSTAL_CODE')}
                disabled={true}
                type="text"
                name=""
                value={shippingPostCode}
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('COMPANY_ADDRESS')}
                disabled={true}
                type="text"
                name=""
                value={shippingCompanyAddress}
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('SHIPPING_CHARGE')}
                disabled={true}
                type="text"
                name=""
                value={shippingCharges}
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('SHIPPING_CALCULATION')}
                disabled={true}
                type="text"
                name=""
                value={shippingCalculation}
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyTextField
                label={t('SHIPPING_CHARGES')}
                disabled={true}
                type="text"
                name=""
                value={shippingRate}
                maxLength={10}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              {/* <BakeasyLabelText
                label={t('PREFERRED_SHIPPING_METHOD')}
                value={preferredShippingMethod}
              /> */}

              <BakeasyTextField
                label={t('SHIPPING_METHOD')}
                disabled={true}
                type="text"
                name=""
                value={preferredShippingMethod}
                maxLength={10}
              />
            </Grid>
          </Grid>

          <BakeasyDivider />
          {/* <Grid>
            {ordersList.length > 0 ? (
              <BakeasySimpleTable
                headers={tableHeaders}
                tableData={ordersList}
                count={ordersList.length}
                refreshPageData={() => {}}
                type={'invoiceDetails'}
                data={total}
              />
            ) : (
              <BakeasyEmptyMsg message={'No Data Found'} />
            )}
          </Grid> */}
          <Grid>
            {products?.length > 0 ? (
              <BakeasySimpleTable
                headers={tableHeaders}
                tableData={products}
                type={'invoiceDetails'}
                data={total}
              />
            ) : (
              <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
            )}
          </Grid>
        </Paper>
      </Grid>
    );
  }

  return invoiceDetailsUI();
};
